import { MatTableDataSource } from '@angular/material/table';

import { CardsFeedbackTableRow } from '../ui/interfaces/cards-feedback.interface';

export const CARD_COLUMNS: Record<string, string> = {
  id: 'id',
  cardBin: 'Card BIN',
  cardLast4: 'Card Last 4',
  cardNumber: 'Card Number',
  cardSvc: 'Card SVC',
  cardCVV: 'Card CVV',
  cardTrack1: 'Track 1 Data',
  cardTrack2: 'Track 2 Data',
  cardExpiration: 'Expiration Date',
  accountHolderName: 'Account Holder Name',
  accountHolderAddress: 'Address',
  accountHolderInfo: 'Address, Phone And Email',
  accountHolderPhone: 'Phone',
  accountHolderEmail: 'Email',
  purchaseDate: 'Purchase Date',
  feedbackValid: 'Valid',
  feedbackFraudDate: 'Fraud Report Date',
  feedbackFraudAmount: 'Fraud Amount',
  feedbackComments: 'Comments',
  feedbackCPP: 'Common Point of Purchase',
  targetName: 'Target Name',
  baseName: 'Base Name',
  no: 'No',
  yes: 'Yes',
};

export const CARDS_FEEDBACK_COLUMNS_MAP: { [key: string]: string } = {
  cardNumber: 'Card Number',
  cardBin: 'Card Bin',
  cardLast4: 'Card Last 4',
  cardExpiration: 'Card Expiration',
  accountHolderName: 'Account Holder Name',
  accountHolderAddress: 'Account Holder Address',
  accountHolderZip: 'Account Holder Zip',
  accountHolderPhone: 'Account Holder Phone',
  accountHolderEmail: 'Account Holder Email',
  sourceCoverName: 'Source Name',
  feedbackValid: 'Feedback Valid',
  feedbackAction: 'Feedback Action',
  feedbackFraudDate: 'Feedback Fraud Date',
  feedbackFraudAmount: 'Feedback Fraud Amount',
  feedbackCPP: 'Feedback Common Point of Purchase',
  feedbackComments: 'Feedback Comments',
};

export interface CardsFeedbackConfig {
  title: string;
  displayedColumns: string[];
}

export const BULK_IMPORT_CSV_COLUMNS = [
  'cardNumber',
  'cardBin',
  'cardExpiration',
  'expirationMonth',
  'expirationYear',
  'cardLast4',
  'cardCVV',
  'cardTrack1',
  'cardTrack2',
  'accountHolderAddress',
  'addressStreet1',
  'addressStreet2',
  'addressCity',
  'addressState',
  'accountHolderZip',
  'accountHolderName',
  'accountHolderFirstName',
  'accountHolderLastName',
  'accountHolderPhone',
  'accountHolderCountry',
  'accountHolderEmail',
  'accountHolderDOB',
  'accountHolderIP',
  'accountPIN',
  'accountPassword',
  'baseName',
  'targetName',
  'price',
  'cardBankName',
  'cardBrand',
  'cardCountry',
  'cardLevel',
  'cardSource',
  'cardSvc',
  'cardType',
  'firstSeenDate',
  'quantity',
  'tags',
  'accountHolderSSN',
  'hasSSN',
];

export interface CardsFeedbackState extends CardsFeedbackConfig {
  totalSize: number;
  results: MatTableDataSource<CardsFeedbackTableRow>;
}

export const createCardsFeedbackState = (
  config: CardsFeedbackConfig
): CardsFeedbackState => ({
  ...config,
  totalSize: 0,
  results: new MatTableDataSource<CardsFeedbackTableRow>([]),
});

export const PURCHASED_CARDS_CONFIG: CardsFeedbackConfig = {
  title: 'Purchased Cards',
  displayedColumns: [
    'cardNumber',
    'cardExpiration',
    'feedbackValid',
    'feedbackFraudDate',
    'feedbackFraudAmount',
    'feedbackComments',
    'feedbackCPP',
  ],
};

export const LAST_4_CARDS_CONFIG: CardsFeedbackConfig = {
  title: 'Cards Last 4',
  displayedColumns: [
    'cardBin',
    'cardLast4',
    'cardExpiration',
    'feedbackValid',
    'feedbackFraudDate',
    'feedbackFraudAmount',
    'feedbackComments',
    'feedbackCPP',
  ],
};

export const ACCOUNT_HOLDER_CARDS_CONFIG: CardsFeedbackConfig = {
  title: 'Cards Account Holder',
  displayedColumns: [
    'cardBin',
    'cardExpiration',
    'accountHolderName',
    'feedbackValid',
    'feedbackFraudDate',
    'feedbackFraudAmount',
    'feedbackComments',
    'feedbackCPP',
  ],
};

export const BOTNET_CARDS_CONFIG: CardsFeedbackConfig = {
  title: 'Botnet Cards',
  displayedColumns: [
    'cardNumber',
    'cardExpiration',
    'feedbackValid',
    'feedbackFraudDate',
    'feedbackFraudAmount',
    'feedbackComments',
    'feedbackCPP',
  ],
};

export const TROUBLE_CARDS_CONFIG: CardsFeedbackConfig = {
  title: 'Trouble Cards',
  displayedColumns: [],
};

export const CARD_PARSER_FIELD_LABELS: Record<string, string> = {
  unknown: 'Unknown',
  cardNumber: 'Card Number',
  cardBin: 'Card BIN',
  cardExpiration: 'Expiration Date',
  cardCVV: 'CVV',
  cardTrack1: 'Track 1',
  cardTrack2: 'Track 2',
  cardCountry: 'Card Country',
  accountHolderName: 'Account Holder Name',
  accountHolderAddress: 'Address',
  accountHolderCity: 'City',
  accountHolderState: 'State',
  accountHolderZip: 'ZIP / Postal Code',
  accountHolderCountry: 'Country',
  accountHolderEmail: 'Email',
  accountHolderPhone: 'Phone',
  accountHolderDOB: 'Date of Birth',
  accountHolderIP: 'IP Address(es)',
  accountHolderSSN: 'SSN',
  accountPassword: 'Password',
  price: 'Price',
  baseName: 'Base Name',
};
